var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_19_13986)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_13986",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_13986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 3H3V23H37.2819V3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 9.6622H3V22.9933H37.2819V9.6622Z",
    fill: "#303E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.2819 16.3311H3V23H37.2819V16.3311Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.18915 7.70037C7.78741 7.73385 7.90124 8.22263 7.84767 8.49715C7.70706 10.4121 7.50619 12.3807 8.09541 14.242C8.55741 15.7419 9.65551 16.9873 10.9879 17.7841C11.316 17.9648 11.6374 18.1992 11.999 18.2929C12.3806 18.1858 12.7154 17.9448 13.0569 17.7506C14.3693 16.9538 15.4473 15.7218 15.9026 14.2354C16.4985 12.3405 16.2842 10.3385 16.1436 8.39002C16.1235 8.1222 16.1637 7.66019 15.7687 7.68698H8.18915V7.70037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 7.99498V17.9916C7.37228 15.7486 7.88116 12.0392 8.18916 7.99498H11.999ZM11.999 7.99498V17.9916C16.6257 15.7486 16.1168 12.0392 15.8088 7.99498H11.999Z",
    fill: "#BD1F34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5414 10.7402C13.0301 10.7402 13.5256 10.8273 14.001 10.921C13.8604 10.459 13.8604 10.1711 14.001 9.70907C13.5256 9.80281 13.0301 9.88986 12.5414 9.88986H11.4634C10.9746 9.88986 10.4791 9.80281 10.0037 9.70907C10.1443 10.1711 10.1443 10.459 10.0037 10.921C10.4791 10.8273 10.9746 10.7402 11.4634 10.7402H12.5414Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9565 12.5614C13.4453 12.5614 13.9407 12.6485 14.4161 12.7422C14.2755 12.2802 14.2755 11.9923 14.4161 11.5303C13.9407 11.624 13.4453 11.7111 12.9565 11.7111H11.0348C10.546 11.7111 10.0506 11.624 9.57516 11.5303C9.71577 11.9923 9.71577 12.2802 9.57516 12.7422C10.0506 12.6485 10.546 12.5614 11.0348 12.5614H12.9565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3897 8.37663C11.4834 8.85202 11.5772 9.3475 11.5772 9.82959V16.0231H12.4275V9.82959C12.4275 9.3475 12.5146 8.85202 12.615 8.37663C12.1396 8.52394 11.8584 8.52394 11.3897 8.37663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0773 14.5233C9.52828 14.5233 9.08636 14.9652 9.08636 15.5075C9.08636 15.5477 9.09306 15.5879 9.09976 15.6281C9.29393 15.9093 9.51489 16.1838 9.76932 16.4449C9.86976 16.4784 9.97019 16.4985 10.0773 16.4985C10.6264 16.4985 11.0683 16.0566 11.0683 15.5075C11.075 14.9652 10.6264 14.5233 10.0773 14.5233Z",
    fill: "#303E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999 13.9407C11.3026 13.9407 10.7402 14.5032 10.7402 15.1995C10.7402 15.8959 11.3026 16.4583 11.999 16.4583C12.6953 16.4583 13.2578 15.8959 13.2578 15.1995C13.2578 14.5032 12.6953 13.9407 11.999 13.9407Z",
    fill: "#303E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9206 14.5233C13.3716 14.5233 12.9297 14.9652 12.9297 15.5075C12.9297 16.0566 13.3716 16.4985 13.9206 16.4985C14.0278 16.4985 14.1282 16.4784 14.2286 16.4449C14.4898 16.1838 14.7107 15.9093 14.9049 15.6281C14.9116 15.5879 14.9183 15.5477 14.9183 15.5075C14.9116 14.9652 14.463 14.5233 13.9206 14.5233Z",
    fill: "#303E99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25375 15.849C9.86306 16.6592 10.7335 17.389 11.999 17.9983C13.2645 17.3823 14.1349 16.6592 14.7442 15.849H9.25375Z",
    fill: "#303E99"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_19_13986",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_19_13986"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_19_13986",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlovakia);
export default __webpack_public_path__ + "static/media/Slovakia.f5b7e5236fe874fe01d33dcff6d2fcc0.svg";
export { ForwardRef as ReactComponent };